import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';

// 1. Immediate Global Error Capture (Defensive)
window.onerror = function (msg, url, line, col, error) {
  const errorMsg = `JS Error: ${msg}\nLine: ${line}\nFile: ${url}`;
  console.error(errorMsg);
  return false;
};

window.onunhandledrejection = function (event) {
  console.error('Unhandled Promise:', event.reason);
};


const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const root = ReactDOM.createRoot(document.getElementById('root'));

const content = (
  <GoogleOAuthProvider clientId={clientId || 'placeholder'}>
    <App />
  </GoogleOAuthProvider>
);

root.render(
  <React.StrictMode>
    {content}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
